// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1UieO","col":"styles_col__3CyFS"};